module.exports = __webpack_public_path__ + "static/media/loginBgImage.c1a1642e.png";